export default __webpack_public_path__ + "static/media/uflag.734ad5cc.jpg";